export default __webpack_public_path__ + "static/oluwatobi-5e572bbe33a084158033220b6dce47ea.png";